module.exports = __webpack_public_path__ + "img/progress_box_bg.53597dac.png";